// Client-side Sentry init for marketing-consumer. instrumentation-client.ts is Next's
// client instrumentation entry and the only client init that runs under Turbopack
// (Next 16 default) — the legacy sentry.client.config.ts is ignored there.
;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/password-reset\"},{\"path\":\"/verification\"}]}";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["_sentryTunnelRouteMode"] = "rewrite";globalThis["_sentryNextJsVersion"] = "16.4.3";import * as Sentry from "@sentry/nextjs";

import { configureSentryClient } from "@ergon-ai/utils-web/sentry/configure-client";

// Session replay records the page, so it waits for the cookie banner's answer.
// ConsentGateway in the root layout mounts the gate that adds it.
configureSentryClient({ gateReplayOnConsent: true });

// Required by Sentry to instrument client-side navigations.
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
